import apiClient from '../apiClient';

export const fetchUsers = async () => {
  const response = await apiClient.get('/users');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data;
};

export default {
  fetchUsers,
};
